module.exports = __webpack_public_path__ + "assets/img/title-c21f4596.png";